import styled, { css } from 'styled-components';

import { rotate } from '../../helpers/styleHelpers';
import { loadingConsts } from './Loading.consts';
import { LoadingSize } from './Loading.types';

type ContainerProps = {
  size: LoadingSize;
};
const Container = styled.svg<ContainerProps>`
  ${({ size }) => css`
    width: ${loadingConsts[size].size};
    height: ${loadingConsts[size].size};
    overflow: inherit;
    animation: ${rotate} 0.5s linear infinite;
  `}
`;

type CircleProps = {
  size: LoadingSize;
};
const Circle = styled.circle<CircleProps>`
  ${({ size }) => css`
    stroke-width: ${loadingConsts[size].thickness};
    fill: transparent;
  `}
`;

const Background = styled(Circle)`
  ${({ theme }) => css`
    stroke: ${theme.border.subtle};
  `}
`;

const Highlighted = styled(Circle)`
  ${({ type, theme }) => css`
    ${type === 'default' &&
    css`
      stroke: ${theme.focus.strong};
    `}

    ${type === 'primary' &&
    css`
      stroke: ${theme.text.onPrimary.strong};
    `}

    ${type === 'tertiary' &&
    css`
      stroke: ${theme.text.onTertiary.strong};
    `}
    
    stroke-linecap: round;
    stroke-dasharray: 100 100;
    stroke-dashoffset: 75;
    transition: stroke-dashoffset 1s;
  `}
`;

export { Container, Background, Highlighted };
